import { Node } from "../node";

export class ContinueNode extends Node {
  get defaults() {
    return {
      ...super.defaults,
      name: "ContinueNode",

      step: false,

      title: undefined,
      message: undefined,
    };
  }

  get possibleNextNodeIds() {
    return ["allow-booking", "missing-visit-type"];
  }

  autoAdvance(context) {
    return !this.step || context.visitTypeId === undefined;
  }

  nextNodeId(context) {
    if (context.switchTreeExitNodeId) {
      return context.switchTreeExitNodeId;
    }

    return context.bookingVisitTypeId ? "allow-booking" : "missing-visit-type";
  }
}
